/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionUnit = function (code, stage, data) {
    this.code = code;
    this.stage = stage;

    this.x = undefined;
    this.y = undefined;

    this.components = Merge2MissionComponentsFactory.create(this, data);
};

Merge2MissionUnit.prototype.getStageConfig = function () {
    return Merge2MissionFamilies.getStageConfig(this.code, this.stage);
};

Merge2MissionUnit.prototype.getType = function () {
    return this.getStageConfig().type;
};

Merge2MissionUnit.prototype.getReward = function () {
    const stageConfig = this.getStageConfig();

    return [Merge2MissionFamilies.TYPE.DROP, Merge2MissionFamilies.TYPE.COLLECT].includes(stageConfig.type) ? stageConfig.reward : undefined;
};

Merge2MissionUnit.prototype.getRewardType = function () {
    const reward = this.getReward();

    return reward && Object.keys(reward)[0];
};

Merge2MissionUnit.prototype.getRewardAmount = function () {
    const reward = this.getReward();

    return reward ? reward[this.getRewardType()] : 0;
};

Merge2MissionUnit.prototype.findComponent = function (Component) {
    return this.components.find((component) => component instanceof Component);
};

Merge2MissionUnit.prototype.findMinable = function () {
    return this.components.find((component) => component.canMine());
};

Merge2MissionUnit.prototype.isMovable = function () {
    return this.components.every((component) => component.isMovable());
};

Merge2MissionUnit.prototype.isMergeable = function () {
    return this.components.every((component) => component.isMergeable());
};

Merge2MissionUnit.prototype.isRevealed = function () {
    const grounded = this.findComponent(Merge2MissionGroundedComponent);
    return !grounded || !grounded.isFog();
};

Merge2MissionUnit.prototype.isGrounded = function () {
    return Boolean(this.findComponent(Merge2MissionGroundedComponent));
};

Merge2MissionUnit.prototype.getMergeResult = function (otherUnit) {
    return this.findComponent(Merge2MissionMergeComponent).getMergeResult(otherUnit);
};

Merge2MissionUnit.prototype.save = function () {
    const data = {};

    this.components.forEach((component) => {
        if (component.save) {
            component.save(data);
        }
    });

    return Object.keys(data).length ? data : undefined;
};
